import services from 'admin/services'

export default {
  setDefaultCompetencies(positionId, context) {
    const parent = context === 'jobAd' ? 'job-ads' : 'interviews'
    const url = `/v1/admin/${parent}/${positionId}/competencies/defaults`

    return services.fetch(
      url,
      { method: 'POST' }
    )
  },
}
